import React, { useState, useEffect } from 'react';
import Socials from './Socials';
import MobileNav from './MobileNav';
import { Link } from 'react-router-dom';
import '../index.css'
import { RiArrowDropDownLine } from "react-icons/ri";
import { useNavigate } from 'react-router-dom';
import logo from '../img/header/new.png'
import mundus from '../img/header/mundus.png'


const Header = () => {

  const [activePage, setActivePage] = useState("")
  const [user, setUser] = useState(JSON.parse(localStorage.getItem('profile')))
  const [showDropDown, setShowDropDown] = useState(false)
  const navigate = useNavigate()
  console.log(user)

  

  return (
    <header className='bg-zinc-900 fixed w-full px-[20px] lg:px-[80px] z-30 h-[80px] lg:h-[90px] flex items-center backdrop-blur-xl animate-fade-in'>
      <div className='flex flex-col lg:flex-row lg:items-center w-full justify-between'>

        <Link
  to={'/'}
  className='max-w-[280px]'
>
  <div className='flex items-center gap-x-3' onClick={() => {setShowDropDown(false); setActivePage("")}}>
    <img src={mundus} className='w-14 h-14 object-contain' alt='logo'/>
    <h1 className='text-white text-lg font-semibold hidden lg:flex'>
      Mundus Axis
    </h1>
  </div>
</Link>

        {/* nav - initially hidden - show on desktop mode */}
        
          <nav
          className='hidden xl:flex gap-x-12 font-semibold flex-grow justify-end'
        >
          <Link
            to={'/open-calls'}
            onClick={() => {setActivePage("OpenCalls"); setShowDropDown(false)}}
            className={`text-gray-300 rounded-lg p-3 hover:scale-110 transition ${activePage === "OpenCalls" ? ' underline decoration-gray-300 decoration-5 ' : ''}`}
          >
            Open Calls
          </Link>

          <Link
            to={'/about'}
            onClick={() => {setActivePage("About"); setShowDropDown(false)}}
            className={`text-gray-300 rounded-lg p-3 hover:scale-110 transition ${activePage === "About" ? ' underline decoration-gray-300 decoration-5' : ''}`}
          >
            Board
          </Link>

          <Link
            to={'/album'}
            onClick={() => {setActivePage("album"); setShowDropDown(false)}}
            className={`text-gray-300 rounded-lg p-3 hover:scale-110 transition ${activePage === "album" ? ' underline decoration-gray-300 decoration-5 ' : ''}`}
          >
            Gallery
          </Link>

         <div className='relative inline-block text-left'>
  <div className='flex items-center'>
    <Link
      to={'/projects'}
      onClick={() => {setActivePage("Editions"); setShowDropDown(false)}}
      className={`text-gray-300 relative rounded-lg p-3 hover:scale-110 transition ${activePage === "Editions" ? 'underline decoration-gray-300 decoration-5' : ''}`}
    >
      Projects
    </Link>
    
    <div onClick={() => setShowDropDown(!showDropDown)} className='text-gray-200 hover:cursor-pointer text-3xl'>
      <RiArrowDropDownLine />
    </div>
  </div>
  {showDropDown && (<div className='absolute mt-1 hover:cursor-pointer w-full bg-white text-black rounded shadow-lg z-10'>
    <div onClick={() => {navigate("/We"); setShowDropDown(false)}} className='p-3 border-b-2 text-zinc-800 border-gray-400 text-xs hover:bg-zinc-900 hover:text-white'>
      WeCollective
    </div>
    <div onClick={() => {navigate("/weightOfWaters"); setShowDropDown(false)}} className='p-3 text-xs border-b-2 text-zinc-800 border-gray-400 hover:bg-zinc-900 hover:text-white'>
      Weight of Waters
    </div>
    <div onClick={() => {navigate("/MGOP"); setShowDropDown(false)}} className='p-3 text-xs border-gray-400 text-zinc-800 hover:bg-zinc-900 hover:text-white'>
      Mapping Geographies of Power  
    </div>
  </div>)}
</div>


          <Link
            to={'/contact'}
            onClick={() => {setActivePage("Contact"); setShowDropDown(false)}}
            className={`text-gray-300 rounded-lg p-3 hover:scale-110 transition ${activePage === "Contact" ? 'underline decoration-gray-300 decoration-5' : ''}`}
          >
            Join Us
          </Link>
        </nav>
        
        
      </div>
              <MobileNav/>

    </header>
  );
};

export default Header;
